import React from "react";
import { Breadcrumb } from "../../components/ui";
import { useParams } from "react-router-dom";
import { TenantForm } from "../../components/Forms/TenantForm";
import { useGetTenantByIdQuery } from "../../store/services/tenants";
import { ProgressSpinner } from "primereact/progressspinner";

export const EditTenant = () => {
  const { tenantId } = useParams<{ tenantId: string }>();
  const { data: tenant, isLoading, error } = useGetTenantByIdQuery(tenantId!);

  if (isLoading) {
    return (
      <div className="flex justify-content-center align-items-center" style={{ height: '200px' }}>
        <ProgressSpinner />
      </div>
    );
  }

  if (error || !tenant) {
    return (
      <div className="grid">
        <div className="col-12">
          <div className="card">
            <h5>Error</h5>
            <p>No se pudo cargar el tenant solicitado.</p>
          </div>
        </div>
      </div>
    );
  }

  const initialValues = {
    id: tenant.id,
    provider: tenant.provider,
    theme: tenant.theme,
    logo: tenant.logo || "",
    alternateLogo: tenant.alternateLogo || "",
    profileLogo: tenant.profileLogo || "",
    emailDomain: tenant.emailDomain || "",
    showMainBanner: !!tenant.showMainBanner || false,
    defaultShowEventMap: !!tenant.defaultShowEventMap || false,
  };

  return (
    <div className="grid">
      <Breadcrumb items={[{ label: "Tenants", to: "/tenants" }, { label: "Editar tenant" }]} />
      <div className="col-12">
        <div className="card">
          <div className="flex align-items-center justify-content-between mb-4">
            <h3 className="text-2xl font-semibold text-900 m-0">
              <i className="pi pi-pencil mr-2 text-primary"></i>
              Editar Tenant: {tenant.provider}
            </h3>
            <div className="flex align-items-center gap-2 text-600">
              <small>ID: {tenant.id}</small>
            </div>
          </div>
          <TenantForm 
            initialValues={initialValues}
            isEdit={true} 
          />
        </div>
      </div>
    </div>
  );
};
